import { request } from '../../../lib/axios'

type ZendeskLoginResponse = {
  jwt: string
  jwt_req_url: string
  return_to: string
}

export const getZendeskLinkAndToken = (userId: number) =>
  request<ZendeskLoginResponse>({
    url: `/users/${userId}/customer-support/help-center-auth`,
    method: 'GET',
  })
